// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__+ljAu","line":"PageHeader_line__64V5N","closeContainer":"PageHeader_closeContainer__fNerG","text":"PageHeader_text__euNVb"};